export async function useFetchCountySubdivision({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
  }));
  return useLazyFetch("/api/county-subdivison", {
    params,
  });
}

export async function useFetchZone({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
  }));
  return useLazyFetch("/api/zone", {
    params,
  });
}

export async function useFetchSchoolDistrict({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
  }));
  return useLazyFetch("/api/school-district", {
    params,
  });
}

export async function useFetchCicadas({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
  }));
  return useLazyFetch("/api/cicadas", {
    params,
  });
}

export async function useFetchSchoolDistrictDetails({ id }) {
  if (!id) {
    throw new Error("Invalid id");
  }
  return useLazyFetch("/api/school-district/details", {
    params: { id },
  });
}

export async function useFetchPeaks({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
  }));
  return useLazyFetch("/api/peaks", {
    params,
  });
}

export async function useFetchSnow({ latitude, longitude }, date = null) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
    date: date ?? undefined,
  }));
  return useLazyFetch("/api/snow", {
    params,
  });
}

export async function useFetchSnowExtremes({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
  }));
  return useLazyFetch("/api/snow/extremes", {
    params,
  });
}

export async function useFetchForecast({ latitude, longitude }, type) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 2),
    longitude: round(longitude, 2),
    type,
  }));
  return useLazyFetch("/api/forecast", {
    params,
  });
}

export async function useFetchAPIElevation({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    latitude: round(latitude, 4),
    longitude: round(longitude, 4),
  }));
  return useLazyFetch("/api/elevation", {
    params,
    transform: (response) => response?.elevation,
  });
}
